import { useQuery } from '@apollo/client';
import { getVisitorWatchlists } from 'graphql-queries';

export const useVisitorWatchlists = (channelId: string) => {
  const { data, loading, error, refetch } = useQuery(getVisitorWatchlists, {
    variables: { filter: { organizationId: channelId } },
    fetchPolicy: 'network-only',
    notifyOnNetworkStatusChange: true,
    skip: !channelId,
  });

  return {
    data: data?.visitorWatchlists,
    loading,
    error,
    refetch,
  };
};
